import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { sendClick } from 'reaxl-analytics';
import { Button, Glyphicon, LinkIcon } from 'reaxl';
function OwnerWebsiteCTA(_ref) {
  let {
    bsStyle = 'primary',
    className,
    hideIcon = false,
    href = '',
    label,
    analyticsData,
    onClick = () => {},
    uiContext = 'default',
    target = '_blank',
    ...rest
  } = _ref;
  if (!href) return null;
  const handleClick = event => {
    event.stopPropagation();
    sendClick('ownerWebsite', event, analyticsData);
    if (onClick()) {
      event.preventDefault();
    }
  };
  const handleRightClick = event => {
    event.stopPropagation();
    sendClick('ownerWebsite', event, analyticsData);
  };
  const buttonProps = {
    target,
    rel: 'nofollow noopener',
    href,
    bsStyle,
    onClick: handleClick,
    onContextMenu: handleRightClick,
    className: clsx({
      'padding-0': bsStyle === 'link'
    }, className),
    'data-cmp': 'ownerWebsiteCTA',
    ...rest
  };
  const glyph = 'offsite';
  const glyphClassName = 'margin-left-1';
  const buttonLabel = label || 'Visit Dealer Website';
  if (uiContext === 'link') {
    return /*#__PURE__*/React.createElement(LinkIcon, Object.assign({}, buttonProps, {
      partner: true,
      placement: "after",
      undecorated: true
    }), buttonLabel);
  }
  if (uiContext === 'unstyledLink') {
    return /*#__PURE__*/React.createElement(LinkIcon, Object.assign({}, buttonProps, {
      className: "link-unstyled",
      placement: "after",
      undecorated: true
    }), buttonLabel);
  }
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, buttonProps, {
    block: uiContext === 'block'
  }), buttonLabel, !hideIcon && /*#__PURE__*/_jsx(Glyphicon, {
    className: glyphClassName,
    glyph: glyph,
    "aria-hidden": "true"
  }));
}
export default OwnerWebsiteCTA;